
import './App.css';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import 'regenerator-runtime';

const API_KEY = "018f0b97-409a-7a3a-a7c2-c2ed98e0013b"



function App({ instance }) {

  const navigate = useNavigate();

  useEffect(( ) => {

    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const value = params.get('key');
   
    if (value === API_KEY) {
      navigate("/ui", { "state": {"key":  value } });
    } else {
      navigate("/error")
    }




  }, [ ]);


  return (
    <div className="App">
    </div>
  );
}

export default App;
